import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import TypeUtils from '../utils/TypeUtils';
import '../style/FeatureDetails.css';
import ResizeableWindow from "qwc2/components/ResizeableWindow";
import FeatureDetailsTab from "../components/FeatureDetailsTab";
import ButtonBar from "qwc2/components/widgets/ButtonBar";
import {selectIndicator} from "../actions/indicators";
import '../style/IndicatorDetails.css';
import IndicatorCompare from "../components/indicators/IndicatorCompare";
import IndicatorObjectList from "../components/indicators/IndicatorObjectList";
import IndicatorRadar from "../components/indicators/IndicatorRadar";
import MultiIndicatorList from "../components/indicators/MultiIndicatorList";
import IndicatorDevelopment from "../components/indicators/IndicatorDevelopment";
import LocaleUtils from "qwc2/utils/LocaleUtils";
import ErrorBoundary, {inlineErrorFallback} from "../components/ErrorBoundary";
import IndicatorTimeslices from "../components/indicators/IndicatorTimeslices";
import IndicatorLegend from "../components/indicators/IndicatorLegend";
import IndicatorLinear from "../components/indicators/IndicatorLinear";
import SingleIndicatorSelect from "../components/indicators/SingleIndicatorSelect";

class IndicatorDetails extends React.Component {
    static propTypes = {
        addLayer: PropTypes.func,
        removeLayer: PropTypes.func,
        selectIndicator: PropTypes.func,
        selectedDate: PropTypes.string,
        selectedIndicator: PropTypes.object,
        selectedObjectType: PropTypes.string,
        windowSize: PropTypes.object
    }
    static defaultProps = {
        windowSize: {
            width: 620,
            height: 640
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            currentTab: ''
        };
    }

    onClose() {
        this.props.selectIndicator(null, null, null);
    }

    setTab = (tabkey) => {
        this.setState({currentTab: tabkey});
    }

    getCurrentTab() {
        if (this.state.currentTab === '') {
            return 'properties';
        }
        return this.state.currentTab;
    }

    getWindowId() {
        return 'indicatorwindow';
    }

    isOpen(tab) {
        return tab === this.getCurrentTab();
    }

    getTabStyle(tab1, tab2) {
        if (this.isOpen(tab1)) {
            return {};
        }
        if (this.isOpen(tab2)) {
            return {};
        }
        return {display: 'none'};
    }

    render() {
        if (!this.props.selectedIndicator) {
            return null;
        }
        const label = this.props.selectedIndicator.name + ' - ' + TypeUtils.getTypeLabel(this.props.selectedObjectType) + ' - ' + this.props.selectedDate;

        const buttons = [
            {key: 'properties', label: LocaleUtils.tr('indicators.properties')},
            {key: 'legend', label: LocaleUtils.tr('indicators.ranges')},
            {key: 'timeslices', label: LocaleUtils.tr('indicators.timeslices')},
            {key: 'compare', label: LocaleUtils.tr('indicators.compare')},
            {key: 'development', label: LocaleUtils.tr('indicators.development')},
            {key: 'linear', label: LocaleUtils.tr('indicators.linear')},
            {key: 'radar', label: LocaleUtils.tr('indicators.radar')}
        ];
        return (
            <div className="indicator-details-wrapper">
                <ResizeableWindow icon="info-sign"
                    initialHeight={this.props.windowSize.height} initialWidth={this.props.windowSize.width}
                    initiallyDocked key={this.getWindowId()}
                    onClose={() => this.onClose()}
                    scrollable
                    title={label}>
                    <div className="service-info-window-body feature-details indicator-details" role="body">
                        <ErrorBoundary fallback={inlineErrorFallback} name="Indikatoren" resetKeys={[this.props.selectedIndicator, this.getCurrentTab()]}>
                        <ButtonBar active={this.getCurrentTab()} buttons={buttons} onClick={this.setTab}/>
                        {this.isOpen('properties') &&
                            <div className="indicator-details-main indicator-details-main-auto">
                                {this.getFeatureTab()}
                            </div>
                        }
                        {this.isOpen('legend') &&
                            <div className="indicator-details-main indicator-details-main-auto">
                                <IndicatorLegend/>
                            </div>
                        }
                        {this.isOpen('timeslices') &&
                            <div className="indicator-details-main indicator-details-main-auto">
                                <IndicatorTimeslices/>
                            </div>
                        }
                        {this.isOpen('compare') &&
                            <div className="indicator-details-main">
                                <IndicatorCompare/>
                            </div>
                        }
                        {this.isOpen('development') &&
                            <div className="indicator-details-main">
                                <IndicatorDevelopment/>
                            </div>
                        }
                        {this.isOpen('linear') &&
                            <>
                                <div className="indicator-details-main">
                                    <IndicatorLinear/>
                                </div>
                                <div>
                                    <SingleIndicatorSelect />
                                </div>
                            </>
                        }
                        {this.isOpen('radar') &&
                            <>
                                <div className="indicator-details-main">
                                    <IndicatorRadar/>
                                </div>
                                <div>
                                    <MultiIndicatorList />
                                </div>
                            </>
                        }
                        <IndicatorObjectList />
                        </ErrorBoundary>
                    </div>
                </ResizeableWindow>
            </div>
        );
    }

    getFeatureTab() {
        const tabConfig = TypeUtils.getTypeConfig(this.props.selectedIndicator.objectType);
        const tab = tabConfig.tabs[0] || {
            view: 'properties'
        };
        // copy, the selected indicator belongs to the redux state and must not be modified
        const feature = {...this.props.selectedIndicator, properties: this.props.selectedIndicator};
        return (
            <FeatureDetailsTab feature={feature} tab={tab} visible
                windowId={this.getWindowId()} windowType={"indicator"} />
        );
    }
}

const selector = (state) => ({
    selectedIndicator: state.indicators.selectedIndicator,
    selectedObjectType: state.indicators.selectedObjectType,
    selectedDate: state.indicators.selectedDate
});

export default connect(selector, {
    selectIndicator: selectIndicator
})(IndicatorDetails);
